export enum ActiviteCode {
    VIN_PROD_RAISIN = 'VIN_PROD_RAISIN',
    VIN_PROD_MOULT = 'VIN_PROD_MOULT',
    VIN_PROD_VIGNIFICATION = 'VIN_PROD_VIGNIFICATION',
    VIN_PROD_ELABORATION = 'VIN_PROD_ELABORATION',
    VIN_PROD_ELEVAGE = 'VIN_PROD_ELEVAGE',
    VIN_PROD_CONDITIONNEMENT = 'VIN_PROD_CONDITIONNEMENT'
}
